var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22603",
    "data-name": "Group 22603",
    transform: "translate(-1101 -693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_14717",
    "data-name": "Path 14717",
    transform: "translate(1101 693)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8 1 C 4.140190124511719 1 1 4.140190124511719 1 8 C 1 11.85980987548828 4.140190124511719 15 8 15 C 11.85980987548828 15 15 11.85980987548828 15 8 C 15 4.140190124511719 11.85980987548828 1 8 1 M 8 0 C 12.41827964782715 0 16 3.581720352172852 16 8 C 16 12.41827964782715 12.41827964782715 16 8 16 C 3.581720352172852 16 0 12.41827964782715 0 8 C 0 3.581720352172852 3.581720352172852 0 8 0 Z",
    stroke: "none",
    fill: "#2585fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_14718",
    "data-name": "Path 14718",
    transform: "translate(1105 697)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0A4,4,0,1,1,0,4,4,4,0,0,1,4,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4 1 C 2.345789909362793 1 1 2.345789909362793 1 4 C 1 5.654210090637207 2.345789909362793 7 4 7 C 5.654210090637207 7 7 5.654210090637207 7 4 C 7 2.345789909362793 5.654210090637207 1 4 1 M 4 0 C 6.209139823913574 0 8 1.790860176086426 8 4 C 8 6.209139823913574 6.209139823913574 8 4 8 C 1.790860176086426 8 0 6.209139823913574 0 4 C 0 1.790860176086426 1.790860176086426 0 4 0 Z",
    stroke: "none",
    fill: "#2585fe"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingIcon);
export default __webpack_public_path__ + "static/media/Listing-Icon.3f2d99f40a163ede986253547084e1e5.svg";
export { ForwardRef as ReactComponent };